import { Component, Inject, OnInit,ViewChild  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParameterResultLetter } from 'app/models/well/samples/parameterResultLetter.viewmodel';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { IHousehold } from 'app/models/household/household';
import { HouseholdLetterUpload } from 'app/models/household/household-letter-upload';
import { HouseholdService } from 'app/services/household-service';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { exportPDF, Group } from '@progress/kendo-drawing';

@Component({
  selector: 'household-exceedence-letter',
  templateUrl: './household-exceedence-letter.component.html',
  styleUrls: ['./household-exceedence-letter.component.scss']
})
export class HouseholdExceedenceLetterComponent implements OnInit {
  @ViewChild('pdf') pdf: PDFExportComponent;
  public environment = environment;
  today: string = '';
  canSave: boolean = false;
  household: IHousehold = undefined;
  parameterResult: ParameterResultLetter = {
    analysisDate: '',
    analysisDatePlusYear: '',
    analyte: '',
    analysisMethod: '',
    contaminant: '',
    labName: '',
    id: 0,
    units: '',
    result: '',
    arsenic: '',
    hasEcoli: false,
    lead: '',
    hasTotalColiform: false,
    nitrate: '',
    nitrateNd: false,
    leadNd: false,
    arsenicNd: false,
    arsenicHigh: false,
    leadHigh: false,
    nitrateDisplay: '',
    createdDate: '',
    createdDatePlusYear: '',
    isRetest: false
  };
  processing: boolean = false;
  processingMessage: string = "";
  letter: HouseholdLetterUpload = {
    id: 0,
    letterHtml: '',
    letterType: '',
    parameterResultId: 0,
    sampleId: 0,
    letterContent: '',
    householdId: 0,
    base64File: ''
  };
  nitrateLevel: number = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: HouseholdLetterUpload,
    private dialogRef: MatDialogRef<HouseholdExceedenceLetterComponent>,
    public householdService: HouseholdService,
    public voucherService: VoucherService,
    private toastr: ToastrService,
    public oregonWellDataService: OregonWellDataService) {
    this.letter = this.data;
  }

  ngOnInit(): void {
    this.today = new Date().toLocaleString('default', { month: 'long' }) + " " + (new Date().getDate()).toString() + ", " + (new Date().getFullYear()).toString();
    this.loadHousehold();
  }

  loadHousehold() {
    this.processing = true;
    this.processingMessage = "Generating";
    this.householdService.getHouseholdById(this.letter.householdId).subscribe(
      result => {
        this.household = result;

          this.voucherService.getParameterResultsBySampleId(this.letter.sampleId).subscribe(
            serviceResult => {
              this.parameterResult = serviceResult;
              if(this.parameterResult != null && this.parameterResult.nitrate != null && this.parameterResult.nitrate != "") {
                this.nitrateLevel = Number(this.parameterResult.nitrate);
              }
              else {
                this.nitrateLevel = 0;
              }
              
              this.processing = false;
              this.processingMessage = "";
              this.canSave = true;
            },
            error => {
              console.log(error.error);
              this.toastr.error("Unable to load result");
              this.processing = false;
              this.processingMessage = "";
            }
          );
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
        this.toastr.error("Unable to load household");
      }
    );
  }

  onSubmit() {
    this.letter.letterHtml = this.oregonWellDataService.stripHtmlComments(document.getElementById('householdLetterPdf').innerHTML);

    this.processing = true;
    this.processingMessage = "Saving Letter";
    this.householdService.uploadLetter(this.letter).subscribe(
      result => {
        this.processingMessage = "";
        this.processing = false;
        this.toastr.success("Household Letter saved");
        this.dialogRef.close();
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  public dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  onSubmitKendo() {
    
    this.pdf.export().then((group: Group) => exportPDF(group)).then((dataUri) => {        
      const base64  = dataUri.replace('data:application/pdf;base64,', '');
      this.letter.letterHtml = '';
      this.letter.base64File = base64;
      this.processing = true;
      this.processingMessage = "Saving Letter";
      this.householdService.uploadLetter(this.letter).subscribe(
        result => {
          this.processingMessage = "";
          this.processing = false;
          this.toastr.success("Household Letter saved");
          this.dialogRef.close();
        },
        error => {
          this.processing = false;
          this.processingMessage = "";
        }
      );
   });
  }
}


